export default __webpack_public_path__ + "static/media/certificates_2.b5ebbdba.jpeg";